import {dateUtils, logging} from "@/utils/utils";
import goalApis from "@/views/GoalSettings/api";
import contractApis from "@/views/ContractManagement/api"

export default function subscriptionApis($apiInstance, $store) {
    const contractApi = contractApis($apiInstance, $store)
    return {
        getSubscriptions: async (params, success, fail) => {
            // const {startDate, endDate} = params
            return $apiInstance.post('/subscriptions', params)
                .then((response) => {
                    success(response);
                }, (error) => {
                    fail(error);
                })
        },
        authorizationCardBySubscription: async (param, success, fail) => {
            return $apiInstance.post(`/subscriptions/check/card/${param.subscriptionId}`, { cardNo: param.cardNo })
                .then((response) => {
                    success(response);
                }, (error) => {
                    fail(error);
                })
        },
        paymentAction: async (subscriptionId) => {
            return $apiInstance.post('/subscriptions/auto/payment/approval', {
                subscriptionIds: [subscriptionId]
            })
                .then((response) => {
                    return response.data
                }, (error) => {
                    return error;
                });
        },
        getSubscriptionById: async (subscriptionId) => {
            return $apiInstance.get(`/subscriptions/${subscriptionId}`)
                .then((response) => {
                    return response.data;
                }, (error) => {
                    return error
                });
        },
        ...contractApi
    }
}